export default {
  filled: {
    '&$positionStart': {
      marginTop: '0!important',
    },
  },
};
